// Globals
import React from 'react';

// Components
import { StyledWrapper, StyledMobileWrapper } from './BannersPreviewStyles';
import Banner from './Banner';
import { IFormInstance, useWatchForm } from '@/components';

// Models
import { DEFAULT_LOCALE } from '@/models/localization.model';

// Helpers
import { BannersFields } from '../../helpers';

type TBannersPreview = {
  formInstance: IFormInstance;
};

const BannersPreview = ({ formInstance }: TBannersPreview) => {
  const values = useWatchForm([], formInstance);

  return (
    <StyledWrapper>
      <Banner
        image={values?.[BannersFields.WEB_MEDIA]}
        title={values?.[BannersFields.LOCALE]?.[DEFAULT_LOCALE]?.title}
        description={values?.[BannersFields.LOCALE]?.[DEFAULT_LOCALE]?.description}
        link={values?.[BannersFields.LOCALE]?.[DEFAULT_LOCALE]?.link}
      />
      <StyledMobileWrapper>
        <Banner
          image={values?.[BannersFields.MOBILE_MEDIA]}
          title={values?.[BannersFields.LOCALE]?.[DEFAULT_LOCALE]?.title}
          description={values?.[BannersFields.LOCALE]?.[DEFAULT_LOCALE]?.description}
          link={values?.[BannersFields.LOCALE]?.[DEFAULT_LOCALE]?.link}
          isMobile
        />
      </StyledMobileWrapper>
    </StyledWrapper>
  );
};

export default BannersPreview;
